<template>
  <v-container grid-list-xl>
    <div v-if="!loading">
      <v-layout wrap v-if="toolOrders.length">
        <v-flex xs12 class="headline"
          ><v-btn
            color="primary"
            class="mr-4"
            small
            outlined
            text
            to="/jobs"
            style="margin-top:-3px"
            ><v-icon left>chevron_left</v-icon>Jobs</v-btn
          >
          {{ toolOrders[0].jobSite.street }}
          <span class="caption" v-if="toolOrders"
            >Order count: {{ toolOrders.length }}</span
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/cost/${toolOrders[0].jobSite.id}`"
            >View Cost Report</v-btn
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/pickups/${toolOrders[0].jobSite.id}`"
            >View Pickup Summary</v-btn
          >
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="toolOrders"
              :search="search"
              :items-per-page="10"
              :loading="loading"
              loading-text="Loading Tool Orders..."
              show-expand
              dense
              :expanded="toolOrders"
            >
              <template v-slot:item.orderNumber="{ item }">
                <span class="subtitle-2"
                  ><a
                    :href="`/tools/manage/orders/${item.orderNumber}`"
                    target="_blank"
                    >#{{ item.orderNumber }}</a
                  ></span
                >
              </template>
              <template v-slot:item.jobSite="{ item }">
                <div style="line-height:16px">
                  {{ item.jobSite.street }}
                  <br />
                  <span style="font-size:12px"
                    >{{ item.jobSite.city }}, {{ item.jobSite.state }}
                    {{ item.jobSite.postalCode }}</span
                  >
                </div>
              </template>
              <template v-slot:item.orderedBy="{ item }"
                >{{ item.orderedBy.firstName }}
                {{ item.orderedBy.lastName }}</template
              >
              <template v-slot:item.fulfilled="{ item }">
                <div v-if="item.fulfilled && !item.cancelled">
                  <v-chip small>
                    <v-icon left small class="pl-1">local_shipping</v-icon
                    >Fulfilled
                  </v-chip>
                </div>
                <div v-if="item.cancelled">
                  <v-chip small>
                    <v-icon left small class="pl-1">close</v-icon>Cancelled
                  </v-chip>
                </div>
                <v-chip
                  small
                  color="amber lighten-3"
                  v-if="!item.fulfilled && !item.cancelled"
                >
                  <v-icon left small class="pl-1">panorama_fish_eye</v-icon
                  >Unfulfilled
                </v-chip>
              </template>
              <template v-slot:item.fulfillmentDate="{ item }">
                <div v-if="item.fulfilled">
                  <div class="grey--text" style="font-size:12px;">
                    {{ item.fulfillmentDate.toDate() | moment("MMM Do h:mma") }}
                  </div>
                  <div
                    v-if="item.fulfilledBy"
                    class="grey--text"
                    style="font-size:12px;"
                  >
                    by {{ item.fulfilledBy.firstName }}
                    {{ item.fulfilledBy.lastName }}
                  </div>
                </div>
              </template>
              <template v-slot:item.orderDate="{ item }">{{
                item.orderDate.toDate() | moment("MMM Do [at] h:mma YYYY")
              }}</template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-0">
                  <v-simple-table dense id="sub-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <td width="310">
                            <span class="caption grey--text">Tool Name</span>
                          </td>
                          <td style="width:200px">
                            <span class="caption grey--text">Requested</span>
                          </td>
                          <td>
                            <span class="caption grey--text">Fulfilled</span>
                          </td>
                          <td>
                            <span class="caption grey--text">Unit Price</span>
                          </td>
                          <td>
                            <span class="caption grey--text">Cost</span>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tool in item.tools" :key="tool.id">
                          <td>
                            {{ tool.title }}
                            <span
                              v-if="tool.isRental"
                              class="red--text text--darken-4 ml-2 caption"
                              >** Rental</span
                            >
                          </td>
                          <td>{{ tool.qty }}</td>
                          <td>
                            {{ fulfilledAmount(tool) }}
                          </td>
                          <td>
                            <span v-if="tool.consumable"
                              >${{ tool.unitPrice.toFixed(2) }}</span
                            >
                            <span v-else>-</span>
                          </td>
                          <td>
                            <span v-if="tool.consumable"
                              >${{ subtotal(tool) }}</span
                            >
                            <span v-else>
                              -
                            </span>
                          </td>
                        </tr>
                        <tr class="total-row">
                          <td><strong>TOTAL:</strong></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <strong v-if="item.cancelled">cancelled</strong>
                            <strong v-else
                              >${{ consumablesCost(item.tools) }}</strong
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-row justify="center" v-if="!loading">
          <v-col class="text-center mt-4 pt-4">
            No tool order data available for this job<br /><br />
            <v-btn color="primary" outlined to="/jobs"
              ><v-icon left>chevron_left</v-icon> Back to jobs</v-btn
            >
          </v-col>
        </v-row>
      </v-layout>
    </div>
    <div v-else>
      <h1 class="display-1 text-center">
        Loading Job Site Date
      </h1>
      <v-text-field color="primary" loading disabled></v-text-field>
    </div>
  </v-container>
</template>
<script>
import fb from "@/main";
import { sumBy, sum } from "lodash";
import utils from "@/helpers/utils";
export default {
  data() {
    return {
      toolOrders: [],
      loading: true,
      search: "",
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        { text: "Ordered By", value: "fullName" },
        { text: "Order Date", value: "orderDate" },
        {
          text: "Fulfilled By",
          value: "fulfillmentDate",

          align: "left",
        },
        { text: "Status", value: "fulfilled" },
      ],
    };
  },
  async created() {
    try {
      this.loading = true;
      const toolOrders = await fb.db
        .collection("toolOrders")
        .where("jobSite.id", "==", this.$route.params.id)
        .orderBy("orderDate", "desc")
        .get();
      this.toolOrders = [];
      toolOrders.forEach((u) => {
        this.toolOrders.push({
          fullName: `${u.data().orderedBy.firstName} ${
            u.data().orderedBy.lastName
          }`,
          id: u.id,
          ...u.data(),
        });
      });
      this.loading = false;
    } catch (err) {
      console.log(err);
      alert("Error getting orders");
      this.loading = false;
    }
  },
  methods: {
    fulfilledAmount(tool) {
      if (!tool.fulfillments) tool.fulfillments = [];
      if (!tool.fulfillments.length) {
        return tool.qtyFulfilled || 0;
      } else {
        return sumBy(tool.fulfillments, "qty");
      }
    },
    consumablesCost(tools) {
      const prices = tools.map((t) =>
        !t.cancelled && t.consumable ? t.unitPrice * this.fulfilledAmount(t) : 0
      );
      const formattedCost = utils.numberWithCommas(sum(prices).toFixed(2));
      return formattedCost;
    },
    subtotal(tool) {
      const subtotal = this.fulfilledAmount(tool) * tool.unitPrice;
      return utils.numberWithCommas(subtotal.toFixed(2));
    },
  },
};
</script>

<style>
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

#sub-table td,
#sub-table thead {
  background: #f7f7f7;
}
tr.total-row td {
  background-color: #ececec !important;
}
</style>
